import type { NodeTypes } from '@xyflow/react';
import ProcessNode from './ProcessNode';

/**
 * Mapping from `Node['type']` (matches the wire `NodeKind`) onto
 * its React Flow renderer. Every kind now points at the same generic
 * {@link ProcessNode} component — kind-specific chrome (label, icon,
 * fields, branches, artifacts panel) is driven entirely by the
 * backend's {@code NodeDefinitionDto} catalog so adding/restyling a
 * kind is a backend-only change.
 *
 * Stable identity matters — React Flow re-mounts custom nodes when the
 * registry reference changes, so we export it as a module-level
 * constant rather than rebuilding it inside a component. The cast to
 * {@link NodeTypes} is needed because {@link ProcessNode} is typed
 * against our specialised {@code ProcessNode<...>} union, structurally
 * narrower than the library's {@code Node<Record<string, unknown>>}
 * default.
 */
export const nodeTypes = {
  input: ProcessNode,
  task: ProcessNode,
  gate: ProcessNode,
  output: ProcessNode,
  note: ProcessNode,
  image_gen: ProcessNode,
  '3d_gen': ProcessNode,
  manual: ProcessNode,
} as unknown as NodeTypes;
